import { mixed, object, array, string } from "yup";

import type { I18nT } from "@lib/dashboardI18n";
import templatableUtil from "@lib/liquid/templatableUtil";
import "@lib/messageComposition/chatMessaging/yupHelper";
import sharedConstants from "@lib/shared_constants";
import { isPersonalizedHttpUrl, isValidHttpUrl } from "@lib/smsLinkShorteningHelper";

import type { RcsSuggestedActionSchemaOptions, RcsSuggestedActionTypes } from ".";

const isLink = (string: string) =>
  templatableUtil.startsWithLiquid(string) || isValidHttpUrl(string) || isPersonalizedHttpUrl(string);

export const getRcsSuggestedActionsSchema = (
  t: I18nT<"rcs-composer">,
  { minActions, maxActions, errorStrings }: RcsSuggestedActionSchemaOptions
) => {
  return array()
    .default([])
    .min(minActions, errorStrings.minActionsError)
    .max(maxActions, errorStrings.maxActionsError)
    .of(
      object({
        type: mixed<RcsSuggestedActionTypes>()
          .oneOf(Object.values(sharedConstants.RCS.ACTION_TYPES))
          .required(errorStrings.actionTypeRequired),
        text: string()
          .required(errorStrings.actionTextRequired)
          .maxLengthIgnoringLiquid(
            sharedConstants.RCS.VALIDATIONS.MAX_CHARACTER_LIMIT_FOR_TEXT_SUGGESTION,
            errorStrings.actionTextLengthError
          ),
        url: string()
          .maxLengthIgnoringLiquid(
            sharedConstants.RCS.VALIDATIONS.MAX_CHARACTER_LIMIT_FOR_URL_SUGGESTION,
            errorStrings.actionUrlLengthError
          )
          .when("type", {
            is: sharedConstants.RCS.ACTION_TYPES.URL,
            then: (schema) =>
              schema
                .required(errorStrings.actionUrlRequired)
                .test("is-valid-website-url", errorStrings.actionUrlInvalidError, isLink),
            otherwise: (schema) => schema.notRequired(),
          }),
      })
    );
};
